import { useState } from 'react'

export default function ShareCodeModal({ code, onClose }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    // 页面只显示 6 位代码，复制内容包含网站地址 + 图纸代码
    const text = `快来查看我的拼豆图纸~ 打开 https://pindou.scsclub.xyz/gallery ，输入图纸代码：${code}`
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // 剪贴板不可用时降级
      const ta = document.createElement('textarea')
      ta.value = text
      document.body.appendChild(ta)
      ta.select()
      document.execCommand('copy')
      document.body.removeChild(ta)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-cocoa/40 p-4 backdrop-blur-sm"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div className="w-full max-w-sm rounded-3xl bg-white p-6 shadow-card">
        <h3 className="text-lg font-bold text-cocoa">分享图纸给好友</h3>
        <p className="mt-1 text-sm text-cocoa-light">
          好友在「拼豆图集」页输入下方 6 位代码即可查看完整图纸。
        </p>

        <div className="mt-5 flex items-center gap-3">
          <div className="flex-1 rounded-2xl bg-cream-100 px-4 py-3 text-center text-2xl font-bold tracking-[0.3em] text-cocoa">
            {code}
          </div>
          <button
            onClick={handleCopy}
            className="rounded-2xl bg-blush px-4 py-3 text-sm font-semibold text-white shadow-soft transition hover:bg-blush-dark"
          >
            {copied ? '已复制' : '复制'}
          </button>
        </div>

        <button
          onClick={onClose}
          className="mt-5 w-full rounded-2xl bg-lavender/30 py-2.5 text-sm font-semibold text-cocoa transition hover:bg-lavender/50"
        >
          关闭
        </button>
      </div>
    </div>
  )
}
